import moment from 'moment';

moment.locale('en-US');
const NumberOfWeeksToShow = 52;

export const weeksList = (): Array<string> => {
  const now = moment().utc().weekday(7).subtract(1, 'days');
  return [
    // GGGG refers to the year of the week. This may be different from YYYY
    // When part of the week is from 2024 and part of it is from 2025. e.g. 2024-12-30 (Monday)
    // In such cases, GGGG refers to the new year (e..g 2025) and YYYY refers to the previous year (e.g. 2024).
    now.format('GGGG-WW'),
    ...Array.from(Array(NumberOfWeeksToShow - 1).keys()).map(() =>
      now.subtract(1, 'weeks').format('GGGG-WW')
    ),
  ];
};

export const getWeekAndYear = (
  weekEncoded: string
): { year: number; week: number } => {
  const [year, week] = weekEncoded.split('-');
  return {
    year: parseInt(year, 10),
    week: parseInt(week, 10),
  };
};

export const getWeekBoundriesList = (): Record<
  string,
  {
    start: string;
    end: string;
  }
> => {
  const now = moment().utc().utc().weekday(7).subtract(1, 'days');
  // @TODO: Fix variable names
  const monday = now.clone().weekday(1).subtract(1, 'days');
  const sunday = now.clone().weekday(7).subtract(1, 'days');

  const returnDict: Record<
    string,
    {
      start: string;
      end: string;
    }
  > = {};
  returnDict[now.format('GGGG-W')] = {
    start: monday.format('YYYY-MM-DD'),
    end: sunday.format('YYYY-MM-DD'),
  };

  for (let i = 0; i <= NumberOfWeeksToShow; i++) {
    returnDict[now.subtract(1, 'weeks').format('GGGG-W')] = {
      start: monday.subtract(1, 'weeks').format('YYYY-MM-DD'),
      end: sunday.subtract(1, 'weeks').format('YYYY-MM-DD'),
    };
  }

  return returnDict;
};

export const getCurrentWeekBoundriesList = (): {
  start: string;
  end: string;
} => {
  const now = moment().utc().weekday(7).subtract(1, 'days');
  return {
    start: now.clone().weekday(1).subtract(1, 'days').format('YYYY-MM-DD'),
    end: now.clone().weekday(7).subtract(1, 'days').format('YYYY-MM-DD'),
  };
};

export const getCurrentWeek = (): string =>
  moment().utc().weekday(7).subtract(1, 'days').format('GGGG-W');

export const getDateRangeFromTimestamp = (
  startTimeStampStr?: string,
  endTimeStampStr?: string
): {
  contactStartDate: string;
  contactEndDate: string;
} => {
  const defaultStart = moment().subtract(1, 'years').format('YYYY-MM-DD');
  const defaultEnd = moment().format('YYYY-MM-DD');
  let safeStart = defaultStart;
  let safeEnd = defaultEnd;
  if (startTimeStampStr) {
    const startDate = moment(startTimeStampStr, 'YYYY-MM-DDTHH:mm:ss[Z]');
    if (startDate.isValid()) {
      safeStart = startDate.format('YYYY-MM-DD');
    }
  }
  if (endTimeStampStr) {
    const endDate = moment(endTimeStampStr, 'YYYY-MM-DDTHH:mm:ss[Z]');
    if (endDate.isValid()) {
      safeEnd = endDate.format('YYYY-MM-DD');
    }
  }
  return {
    contactStartDate: safeStart,
    contactEndDate: safeEnd,
  };
};

export const getDateRangeFromWeek = (
  weekValue: string
): { startDate: string; endDate: string } => {
  const TRAILING_DAYS = 'Trailing 7 days';
  const { year, week } = getWeekAndYear(
    weekValue === TRAILING_DAYS ? getCurrentWeek() : weekValue
  );

  const weekBefore = moment(`${year}-${week}`, 'GGGG-WW').subtract(1, 'weeks');
  const weekAfter = moment(`${year}-${week}`, 'GGGG-WW').add(1, 'weeks');

  return {
    startDate: weekBefore.format('YYYY-MM-DD'),
    endDate: weekAfter.format('YYYY-MM-DD'),
  };
};

export function getFutureWeeks(
  weekCount: number,
  startDate?: string
): string[] {
  const weeks: string[] = [];

  let currentWeek = startDate
    ? moment(startDate).utc().weekday(7).subtract(1, 'days').format('GGGG-W')
    : moment().utc().weekday(7).subtract(1, 'days').format('GGGG-W');

  weeks.push(currentWeek);

  for (let i = 1; i < weekCount; i++) {
    currentWeek = moment(currentWeek, 'GGGG-W').add(7, 'days').format('GGGG-W');
    weeks.push(currentWeek);
  }

  return weeks;
}
